import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initializeAuth } from './auth/AuthClient';
import { loadEnvironment } from './config';
void (async () => {
    await loadEnvironment();
    // Must run before React renders so the OAuth callback ?code= param is
    // captured before React Router's <Navigate> strips it from the URL.
    initializeAuth();
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(_jsx(React.StrictMode, { children: _jsx(App, {}) }));
})();
